
/*
 * Dinner Party: Gift wrapping checkbox
 * Uses Lively's existing add/remove behavior.
 */

document.addEventListener('change', function (event) {
  const checkbox = event.target;

  if (!checkbox.matches('[data-js-cart-wrapping-checkbox]')) {
    return;
  }

  const wrappingContainer = checkbox.closest('#cart-wrapping');
  if (!wrappingContainer) return;

  const sidebar = document.getElementById('site-cart-sidebar');

  if (sidebar && sidebar.contains(wrappingContainer)) {
    sidebar.scrollTo({ top: 0, behavior: 'smooth' });
  }

  if (checkbox.checked) {
    const addButton = wrappingContainer.querySelector(
      '[data-js-product-add-to-cart]'
    );

    if (addButton) {
      addButton.click();
    }
  } else {
    const wrappingItem = document.querySelector(
      '.cart-item--gift-wrapping .remove'
    );

    if (wrappingItem) {
      wrappingItem.click();
    }
  }
});


/*
 * Dinner Party: Remove bottle wrapping
 * automatically when no wine remains.
 */

(function () {
  let cleaningUp = false;

  async function checkBottleWrapping() {
    if (cleaningUp) return;

    const cartForm = document.getElementById('AjaxCartForm');
    if (!cartForm) return;

    const hasWine = !!cartForm.querySelector(
      '[data-js-cart-item][data-is-wine="true"]'
    );

    const wrappingItem = cartForm.querySelector(
      '.cart-item--gift-wrapping'
    );

    // Wrapping is valid, or there is nothing to remove.
    if (hasWine || !wrappingItem) return;

    cleaningUp = true;

    const checkoutButtons = document.querySelectorAll(
      '[name="checkout"]'
    );

    // Prevent checkout during cleanup.
    checkoutButtons.forEach(button => {
      button.disabled = true;
    });

    try {
      const response = await fetch(
        KROWN.settings.routes.cart_change_url,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: wrappingItem.dataset.id,
            quantity: 0
          })
        }
      );

      if (!response.ok) {
        throw new Error('Could not remove bottle wrapping');
      }

      // Use Lively's existing section rendering.
      const sectionResponse = await fetch(
        `?section_id=${window.KT_FILE_PREFIX || ''}helper-cart`
      );

      if (!sectionResponse.ok) {
        throw new Error('Could not refresh cart');
      }

      const html = await sectionResponse.text();

      if (typeof window.renderHelperCart !== 'function') {
        throw new Error('Cart renderer unavailable');
      }

      window.renderHelperCart(html);

      // Notify Lively that the cart has changed.
      cartForm.dispatchEvent(new Event('cart-updated'));

    } catch (error) {
      console.error(
        'Dinner Party bottle wrapping cleanup:',
        error
      );

      // Reload to synchronize the cart if anything fails.
      window.location.reload();
      return;

    } finally {
      cleaningUp = false;
    }

    // Preserve existing disabled states where possible.
    checkoutButtons.forEach(button => {
      if (button.isConnected) {
        button.disabled = false;
      }
    });
  }

  // Capture catches Lively's non-bubbling cart-updated event.
  document.addEventListener(
    'cart-updated',
    checkBottleWrapping,
    true
  );

  // Also catch an invalid cart on initial page load.
  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      checkBottleWrapping
    );
  } else {
    checkBottleWrapping();
  }
})();
